var map = {
	"./Arrow-Left.svg": 9581,
	"./Arrow-Right.svg": 5440,
	"./artful-crib/1.jpg": 4857,
	"./artful-crib/2.jpg": 7742,
	"./artful-crib/cover.svg": 9201,
	"./artful-crib/header.jpg": 9309,
	"./artful-crib/header.webp": 9461,
	"./artful-crib/logo.svg": 6637,
	"./artful-crib/passion-project.png": 2527,
	"./avodah/cover.svg": 1229,
	"./bangle-and-band/logo.svg": 5771,
	"./bangle-and-band/passion-project.png": 349,
	"./bcg/cover.svg": 982,
	"./hdpiano/1.jpg": 4917,
	"./hdpiano/2.jpg": 8666,
	"./hdpiano/3.jpg": 855,
	"./hdpiano/cover.svg": 8981,
	"./hdpiano/header.jpg": 7657,
	"./heart-soil/cover.svg": 8930,
	"./nestle-purina/1.jpg": 5591,
	"./nestle-purina/2.jpg": 2744,
	"./nestle-purina/Screenshot 2024-12-21 at 5.40.45 AM.png": 2540,
	"./nestle-purina/cover.png": 6579,
	"./nestle-purina/cover.svg": 4907,
	"./nestle-purina/header": 7649,
	"./nestle-purina/header.jpeg": 8924,
	"./nestle-purina/header.jpg": 4371,
	"./pharmscript/cover.svg": 9869,
	"./transportation-company/cover.svg": 6846,
	"./unruly-farm/1.jpg": 9690,
	"./unruly-farm/2.jpg": 677,
	"./unruly-farm/cover.svg": 4778,
	"./unruly-farm/header.jpg": 4108,
	"./walmart/1.jpg": 2246,
	"./walmart/2.jpg": 3665,
	"./walmart/cover.svg": 8390,
	"./walmart/header.jpg": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;